"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "oltressenda-alta": {
    "98f4fd2d": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "skipSearch": false
    }],
    "camai": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9671dae7": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "skipSearch": false
    }],
    "centri-nasolino": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f88f1096": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "skipSearch": false
    }],
    "plazzo": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf2c0530": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "skipSearch": false
    }],
    "spinelli": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4bfbcad": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "skipSearch": false
    }],
    "valzurio": [{
      "hkey": "d1e11d35",
      "slug": "oltressenda-alta",
      "name": "Oltressenda Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;